const toTitleCase = (str: string) =>
  str
    .normalize('NFC')
    .toLowerCase()
    .replace(/(^|\s)\p{L}/gu, (c) => c.toUpperCase());

const normalizeSpecialNames = (str: string) =>
  str
    .replace(/^Estruturalms\b/i, 'EstruturalMS')
    .replace(/^Invent[aá]rioms\b/i, 'InventárioMS');

export const getFileDisplayName = (
  file: { fileName?: string; originalFileName?: string },
  index: number,
): string => {
  if (file.originalFileName) {
    const nameWithoutExt = file.originalFileName.replace(/\.[^/.]+$/, '');
    const parts = nameWithoutExt.split(' - ');
    if (parts.length >= 3) {
      const prefix = normalizeSpecialNames(toTitleCase(parts[0]));
      const second = parts[1].trim().substring(0, 5);
      const name = toTitleCase(parts[2]);
      return `${prefix} - ${second} - ${name}`;
    }
    return normalizeSpecialNames(
      toTitleCase(parts[0] ?? `arquivo ${index + 1}`),
    );
  }
  return normalizeSpecialNames(
    toTitleCase(file.fileName?.split('-')[0] ?? `arquivo ${index + 1}`),
  );
};
